export const supportedLocales = ["en", "zh", "ja"];
const fallbackLocale = "en";

export function matchSupportedLocale(tag) {
  if (!tag) return null;
  const normalized = String(tag).toLowerCase().replace(/_/g, "-");
  if (supportedLocales.includes(normalized)) return normalized;
  const primary = normalized.split("-")[0];
  if (supportedLocales.includes(primary)) return primary;
  return null;
}

export function detectBrowserLocale() {
  if (typeof navigator === "undefined") return fallbackLocale;
  const candidates = [];
  if (navigator.languages && navigator.languages.length) {
    candidates.push(...navigator.languages);
  }
  if (navigator.language) candidates.push(navigator.language);
  for (let i = 0; i < candidates.length; i++) {
    const matched = matchSupportedLocale(candidates[i]);
    if (matched) return matched;
  }
  return fallbackLocale;
}

export function resolveInitialLocale() {
  return detectBrowserLocale();
}
